// Auto Week Roll — silently promote next-week → this-week when the calendar
// has moved past the plan's current weekStart. Athletes never have to tap
// "Use as this week" on Monday morning; the roll just happens the next time
// they open the app.
//
// Rules:
//   • rolls happen once per app load and only if plan.weekStart < Monday-of-today
//   • trainingWeek ← nextWeek, nextWeek ← empty
//   • plan.weekStart bumps to this Monday
//   • the caller runs /engine/generate + PUT to persist and refresh macros
const pad2 = (n) => String(n).padStart(2, "0");
const toISO = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
const parseLocal = (iso) => { const [y, m, dd] = iso.split("-").map(Number); return new Date(y, m - 1, dd); };

// Monday of the ISO week containing d, in local time.
export function isoMondayOf(d) {
  const x = new Date(d);
  const dow = (x.getDay() + 6) % 7; // Mon=0
  x.setDate(x.getDate() - dow);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function todayIsoMonday() {
  return toISO(isoMondayOf(new Date()));
}

const emptyWeek = () => ({ days: Array.from({ length: 7 }, () => ({ sessions: [] })) });

// Returns { rolled: boolean, newPlan, gap } — newPlan is a shallow clone with
// prevWeek/trainingWeek/nextWeek + weekStart shifted forward if needed.
export function computeRolledPlan(plan) {
  if (!plan || !plan.weekStart) return { rolled: false, newPlan: plan, gap: 0 };
  const currentMonday = isoMondayOf(new Date());
  const planStart = isoMondayOf(parseLocal(plan.weekStart));
  const gapDays = Math.round((currentMonday - planStart) / 86400000);
  const gap = Math.floor(gapDays / 7);
  if (gap <= 0) return { rolled: false, newPlan: plan, gap: 0 };

  const nextWk = plan.nextWeek?.days ? { ...plan.nextWeek } : emptyWeek();
  return {
    rolled: true,
    gap,
    newPlan: {
      ...plan,
      trainingWeek: nextWk,
      nextWeek: emptyWeek(),
      weekStart: toISO(currentMonday),
    },
  };
}
